
class ErrorLogger {
    static isProduction = process.env.NODE_ENV === 'production';
    static apiEndpoint = null;

    static async logError(error, context = {}) {
        const errorData = {
            message: error.message || 'Unknown error',
            stack: error.stack,
            context: {
                ...context,
                url: window.location.href,
                userAgent: navigator.userAgent,
                timestamp: new Date().toISOString()
            }
        };

        if (!this.isProduction) {
            // Silent logging
        }

        return errorData;
    }

    static logWarning(message, context = {}) {
        const warningData = {
            level: 'warning',
            message,
            context,
            timestamp: new Date().toISOString()
        };

        if (!this.isProduction) {
            // Silent logging
        }

        return warningData;
    }

    static logInfo(message, data = {}) {
        if (!this.isProduction) {
            // Silent logging
        }
    }

    static async trackAction(action, data = {}) {
        if (!this.isProduction) {
            // console.log(`[Action Tracked]: ${action}`, data);
        }
        // Client analytics endpoint not yet implemented in backend
    }

    static createErrorBoundaryHandler(componentName) {
        return (error, errorInfo) => {
            this.logError(error, {
                component: componentName,
                errorInfo: errorInfo?.componentStack
            });
        };
    }
}

export default ErrorLogger;


